"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CDTCodeCategoryType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var CDTCodeCategoryType_Factory = /** @class */ (function () {
    function CDTCodeCategoryType_Factory() {
    }
    CDTCodeCategoryType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    CDTCodeCategoryType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return CDTCodeCategoryType_Factory;
}());
exports.CDTCodeCategoryType_Factory = CDTCodeCategoryType_Factory;
